import queryString from 'query-string';

import { isProduction } from '@/components/signup/utils/environment';

const LOOM_TWC_WELCOME_URL = 'https://www.loom.com/twc/welcome';
const LOOM_TWC_WELCOME_STAGING_URL = 'https://stage.loom.com/twc/welcome';
// Loom serves Atlassian auth from the apex domain in production, not `www`.
const LOOM_ATLASSIAN_AUTH_URL = 'https://loom.com/api/auth/atlassian';
const LOOM_ATLASSIAN_AUTH_STAGING_URL = 'https://stage.loom.com/api/auth/atlassian';

type LoomTwcWelcomeUrlOptions = {
	skipUpgrade?: boolean;
};

export const getLoomTwcWelcomeUrl = (
	siteId: string,
	{ skipUpgrade = false }: LoomTwcWelcomeUrlOptions = {},
) => {
	return queryString.stringifyUrl({
		url: isProduction() ? LOOM_TWC_WELCOME_URL : LOOM_TWC_WELCOME_STAGING_URL,
		query: {
			siteId,
			// query-string serializes null as a valueless parameter (`&skipUpgrade`).
			skipUpgrade: skipUpgrade ? null : undefined,
		},
	});
};

/**
 * Returns a Loom Atlassian auth URL that sends the user to `redirectAfter` once signed in.
 *
 * Loom pages such as `/twc/welcome` require a Loom session, so linking to them directly sends
 * users without one (e.g. brand-new Loom users) to Loom's logged-out `/login` screen. Loom's
 * Atlassian auth creates the Loom session (and account, if needed) before following
 * `redirect_after`.
 */
export const getLoomAtlassianAuthUrl = (redirectAfter: string) => {
	return queryString.stringifyUrl({
		url: isProduction() ? LOOM_ATLASSIAN_AUTH_URL : LOOM_ATLASSIAN_AUTH_STAGING_URL,
		query: {
			redirect_after: redirectAfter,
		},
	});
};
